module.exports = __webpack_public_path__ + "static/media/vegitables_55.0c4825c7.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_55.csv
// module id = 641
// module chunks = 0